import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { WebhookDetails } from "@/components/webhooks/webhook-details"
import { FRONTEND_ROUTES } from "@/constants"

export function WebhookDetailsPage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.WEBHOOKS.href,
              label: t("sidebar.webhooks"),
            },
            {
              label: t("pages.webhooks.webhookDetails"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <WebhookDetails />
      </section>
    </DashboardContainer>
  )
}
